import './../fonts/proximanova.css';

export const globalCss = {
    html: {
        fontFamily: '"Proxima Nova", Arial, sans-serif',
        color: '{colors.bodyText}',
        colorPalette: 'secondary',
    },
};
